export default __webpack_public_path__ + "static/media/img8.4debc904.png";